module.exports = __webpack_public_path__ + "img/quicktips26.7b3ef9ab.svg";